'use client'

import { m } from 'framer-motion'
import { Star } from 'lucide-react'

export type CaseTestimonialBlock = {
  rating?: number
  quote: string
  author: string
  role?: string
  company?: string
}

export default function CaseTestimonial({
  testimonial,
}: {
  testimonial?: CaseTestimonialBlock | null
}) {
  if (!testimonial) return null

  const rating = Math.max(0, Math.min(5, testimonial.rating ?? 5))
  const authorLine = testimonial.company
    ? `${testimonial.role ?? ''}${testimonial.role ? ' / ' : ''}${testimonial.company}`
    : (testimonial.role ?? '')

  return (
    <section className="home-section relative overflow-hidden bg-transparent">
      <div className="home-container">
        <div className="relative overflow-hidden rounded-[28px] border border-white/10 bg-white/[0.03] p-8 text-center backdrop-blur-md sm:rounded-[40px] sm:p-12 md:p-16 lg:p-20">
          <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(99,102,241,0.16)_0%,transparent_60%)]" />

          <m.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ staggerChildren: 0.05 }}
            className="relative z-10 mb-8 flex justify-center gap-2 sm:mb-10"
          >
            {Array.from({ length: 5 }, (_, i) => i + 1).map((s) => (
              <Star
                key={s}
                size={16}
                className={[
                  'sm:h-[18px] sm:w-[18px]',
                  s <= rating ? 'fill-yellow-400 text-yellow-400' : 'fill-white/10 text-white/25',
                ].join(' ')}
              />
            ))}
          </m.div>

          <m.p
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="home-meta relative z-10 mb-5 text-gray-400"
          >
            Отзыв клиента
          </m.p>

          <m.h2
            initial={{ opacity: 0, filter: 'blur(8px)' }}
            whileInView={{ opacity: 1, filter: 'blur(0px)' }}
            viewport={{ once: true }}
            transition={{ duration: 0.75 }}
            className="home-quote relative z-10 mx-auto mb-10 max-w-5xl leading-[1.45] text-white sm:mb-14"
          >
            «{testimonial.quote}»
          </m.h2>

          <m.div
            initial={{ opacity: 0, y: 14 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="relative z-10"
          >
            <div className="home-card-title-sm mb-2 text-white">{testimonial.author}</div>
            <div className="home-subnote text-gray-400">{authorLine || 'Клиент проекта'}</div>
          </m.div>
        </div>
      </div>
    </section>
  )
}
